import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MediaService {
  
  constructor(
    private http: HttpClient
  ) { }

  getAllMedia(): Observable<any> {
    return this.http.get(environment.apiUrl + '/media/getAll');
  }

  deleteImage(id: number): Observable<any> {
    return this.http.delete(environment.apiUrl + '/media/delete/' + id);
  }

}
